import { ExternalLink, Lock } from "lucide-react";

export const EmbeddedSite = ({ url, host, testId, name }) => (
  <div className="rounded-[26px] border border-[#D8D7CE] bg-white shadow-[0_40px_80px_-40px_rgba(7,11,46,0.45)] overflow-hidden" data-testid="embedded-site">
    <div className="flex items-center gap-3 px-4 sm:px-5 py-3 border-b border-[#E3E2DA] bg-[#F7F6F1]">
      <span className="hidden sm:flex gap-1.5">
        <span className="w-3 h-3 rounded-full bg-[#E3E2DA]" />
        <span className="w-3 h-3 rounded-full bg-[#E3E2DA]" />
        <span className="w-3 h-3 rounded-full bg-[#E3E2DA]" />
      </span>
      <span className="flex-1 min-w-0 flex items-center gap-2 rounded-full bg-white border border-[#E3E2DA] px-4 py-1.5 font-mono text-xs text-[#3A3F5C]">
        <Lock className="w-3 h-3 shrink-0 text-[#0B14A0]" /><span className="truncate">{host}</span>
      </span>
      <a href={url} target="_blank" rel="noopener noreferrer" data-testid={testId} className="inline-flex items-center gap-1.5 rounded-full bg-[#070B2E] text-white px-4 py-1.5 text-xs font-semibold transition-colors hover:bg-[#0B14A0] shrink-0">
        Öppna <ExternalLink className="w-3.5 h-3.5" />
      </a>
    </div>
    <iframe
      src={url}
      title={name}
      loading="lazy"
      data-lenis-prevent
      className="w-full h-[560px] sm:h-[680px] lg:h-[760px] bg-white"
      data-testid="embedded-site-iframe"
    />
  </div>
);
